<div class="line-extensions-container">
  <h4 class="mb-3">Line Extensions</h4>
  @if (_lineExtensions.length > 0) {
    <p-table [value]="_lineExtensions" styleClass="p-datatable-sm">
      <ng-template #header>
        <tr>
          <th>Designation</th>
          <th style="width: 150px">Pretreatment</th>
          <th class="text-center" style="width: 80px">Seaside</th>
          <th class="text-center" style="width: 100px">Postforming</th>
        </tr>
      </ng-template>
      <ng-template #body let-extension let-i="rowIndex">
        <tr>
          <td>
            <input
              pInputText
              [(ngModel)]="extension.designation"
              (ngModelChange)="onValueChange()"
              class="w-full"
            />
          </td>
          <td>
            <p-select
              [options]="pretreatmentOptions"
              [(ngModel)]="extension.pretreatment"
              (ngModelChange)="onValueChange()"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              [style]="{ width: '100%' }"
            ></p-select>
          </td>
          <td class="text-center">
            <p-checkbox
              [(ngModel)]="extension.seaside"
              (ngModelChange)="onValueChange()"
              [binary]="true"
            ></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox
              [(ngModel)]="extension.postforming"
              (ngModelChange)="onValueChange()"
              [binary]="true"
            ></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="text-color-secondary">No coating lines available for the selected production site.</p>
  }
</div>
